<div class="login-test">
  <div class="title">
    <h3>Triidy Test <span>Pruebas</span></h3>
    <p>Indique sus credenciales de acceso a pruebas, recuerde que este acceso esta restringido unicamente al personal de
      triidy:
    </p>
  </div>
  <div class="formul">
    <form [formGroup]="loginForm">
      <mat-form-field appearance="outline">
        <mat-label>Usuario</mat-label>
        <input matInput class="inputs" type="input" name="userTest" id="userTest" formControlName="userTest" #userTest
          required>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Contraseña</mat-label>
        <input matInput class="inputs" [type]="hidePass ? 'password' : 'text'" name="passTest" id="passTest"
          formControlName="passTest" autocomplete="off" #passTest required>
        <mat-icon mat-icon-button matSuffix (click)="showPass()" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidePass" class="btn_eye">{{ hidePass ? 'visibility_off' : 'visibility' }}</mat-icon>
      </mat-form-field>

      <ng-container *ngIf="errorLogg">
        <div *ngIf="errorLogg && !showBlockUser && !showStatusError" class="message_alert message_alert--warning">
          <span>Nombre de usuario o contraseña incorrecto.</span>
        </div>
        <div *ngIf="showBlockUser && errorLogg" class="message_alert message_alert--warning">
          <span>Usuario bloqueado por reintentos fallidos.</span>
        </div>
        <div *ngIf="showStatusError && errorLogg" class="message_alert message_alert--warning">
          <span *ngIf="statusError >= 400 && statusError < 500">Solicitud no valida por parte del cliente: {{
            statusError }}</span>
          <span *ngIf="statusError >= 500">No se puede contectar al servidor: {{ statusError }}</span>
        </div>
      </ng-container>

      <div *ngIf="showMessageError" class="message_alert message_alert--warning">
        <span>{{ messageError }}</span>
      </div>
      <div class="cont-btn" *ngIf="true">
        <button type="submit" class="btn" [disabled]="!loginForm.valid" (click)="loginTest()">Iniciar
          Sesión</button>
      </div>
    </form>
  </div>
</div>